/**
 * 国家/地区选择器组件
 * 使用 Alpine.js Store 管理全局状态
 */

// 欧洲国家列表
const EU_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'NO', 'PL', 'PT', 'RO', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH',
  'TR', 'GB', 'MK'
];

// 北美国家列表
const NA_COUNTRIES = ['US', 'CA'];

// 跨站跳转后，在目标站点提交本地化表单以更新 Shopify 市场。
function submitCountryLocalization(countryCode, returnTo) {
  const form = document.getElementById('country-modal-localization-form');
  if (!form) return false;
  form.querySelector('[name="country_code"]').value = countryCode;
  let returnInput = form.querySelector('[name="return_to"]');
  if (!returnInput) {
    returnInput = document.createElement('input');
    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    form.appendChild(returnInput);
  }
  returnInput.value = returnTo;
  // Shopify CLI 本地代理无法处理本地化更新，改由店铺域名接收表单。
  if (['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) {
    form.action = new URL(form.getAttribute('action'), form.dataset.shopUrl).href;
  }
  form.submit();
  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href);
  const country = url.searchParams.get('country_selection');
  if (!country || ![...EU_COUNTRIES, ...NA_COUNTRIES].includes(country)) return;
  url.searchParams.delete('country_selection');
  submitCountryLocalization(country, url.pathname + url.search + url.hash);
});

document.addEventListener('alpine:init', () => {
  /**
   * 全局弹窗状态管理（Alpine.store）
   * 管理弹窗的打开/关闭和临时选中的国家
   */
  Alpine.store('countryModal', {
    // 弹窗是否打开
    open: false,

    // 临时选中的国家代码（弹窗内的选择）
    selectedCountry: '',

    // 弹窗打开后再允许加载国旗，避免页面初始化时请求所有 flag 资源
    flagsLoaded: false,

    // 国家代码到名称的映射
    countryNames: {
      // North America
      'US': 'United States',
      'CA': 'Canada',

      // Europe
      'AT': 'Austria',
      'BE': 'Belgium',
      'BG': 'Bulgaria',
      'HR': 'Croatia',
      'CY': 'Cyprus',
      'CZ': 'Czech Republic',
      'DK': 'Denmark',
      'EE': 'Estonia',
      'FI': 'Finland',
      'FR': 'France',
      'DE': 'Germany',
      'GR': 'Greece',
      'HU': 'Hungary',
      'IE': 'Ireland',
      'IT': 'Italy',
      'LV': 'Latvia',
      'LT': 'Lithuania',
      'LU': 'Luxembourg',
      'MT': 'Malta',
      'NL': 'Netherlands',
      'NO': 'Norway',
      'PL': 'Poland',
      'PT': 'Portugal',
      'RO': 'Romania',
      'RS': 'Serbia',
      'SK': 'Slovakia',
      'SI': 'Slovenia',
      'ES': 'Spain',
      'SE': 'Sweden',
      'CH': 'Switzerland',
      'TR': 'Turkey',
      'GB': 'United Kingdom',
      'MK': 'North Macedonia'
    },

    /**
     * 打开弹窗
     * @param {String} currentCountry - 当前已确认的国家代码
     */
    openModal(currentCountry) {
      // 恢复上次选择的国家（如果有）
      this.selectedCountry = currentCountry || '';
      this.flagsLoaded = true;
      this.open = true;

      // 防止背景滚动
      document.body.style.overflow = 'hidden';
    },

    /**
     * 关闭弹窗
     */
    close() {
      this.open = false;

      // 恢复背景滚动
      document.body.style.overflow = '';
    },

    /**
     * 确认选择
     */
    confirm() {
      if (!this.selectedCountry) {
        // 如果未选择，提示用户
        return;
      }

      // 判断选中的国家是否为欧洲国家
      const isEuropean = EU_COUNTRIES.includes(this.selectedCountry);
      const isNorthAmerican = NA_COUNTRIES.includes(this.selectedCountry);

      // 检查当前站点
      const currentHost = window.location.hostname;
      const isMainSite = currentHost.includes('satellai.com') && !currentHost.includes('global');
      const isGlobalSite = currentHost.includes('global.satellai.com');

      const currentPath = window.location.pathname + window.location.search + window.location.hash;

      // 保存用户手动选择到 localStorage（永久缓存）
      try {
        localStorage.setItem('user_selected_country', this.selectedCountry);
        console.log('[Country Selector] 已保存用户手动选择:', this.selectedCountry);
      } catch (e) {
        console.error('[Country Selector] 保存用户选择失败:', e);
      }

      // 站点切换逻辑
      if (isEuropean && isMainSite) {
        // 欧洲国家但在主站 → 跳转到 global 站点
        const destination = new URL('https://global.satellai.com/');
        destination.searchParams.set('country_selection', this.selectedCountry);
        window.location.href = destination.href;
        return;
      } else if (isNorthAmerican && isGlobalSite) {
        // 北美国家但在 global 站点 → 跳转到主站
        const destination = new URL('https://satellai.com/');
        destination.searchParams.set('country_selection', this.selectedCountry);
        window.location.href = destination.href;
        return;
      }

      if (submitCountryLocalization(this.selectedCountry, currentPath)) return;

      // 如果不需要跳转，触发自定义事件，通知注册表单组件和 header 组件
      document.dispatchEvent(new CustomEvent('country-selected', {
        detail: {
          code: this.selectedCountry,
          name: this.getCountryName(this.selectedCountry),
          flagUrl: this.getFlagUrl(this.selectedCountry)
        }
      }));

      // 关闭弹窗
      this.close();
    },

    /**
     * 根据国家代码获取国家名称
     * @param {String} countryCode - 国家代码
     * @returns {String} 国家名称
     */
    getCountryName(countryCode) {
      return this.countryNames[countryCode] || countryCode;
    },

    /**
     * feat
     * @param {String} region - 国家代码
     * @returns {Boolean} 是否适合当前站点
     */
    isRegionValidForCurrentSite(region) {
      if (!region) {
        return false;
      }

      // 检查当前站点
      const currentHost = window.location.hostname;
      const isMainSite = currentHost.includes('satellai.com') && !currentHost.includes('global');
      const isGlobalSite = currentHost.includes('global.satellai.com');

      // 判断 region 属于哪个站点
      const isNorthAmerican = NA_COUNTRIES.includes(region);
      const isEuropean = EU_COUNTRIES.includes(region);

      // 匹配规则：
      // 1. 主站（北美站）：只接受北美国家
      // 2. Global 站（欧洲站）：只接受欧洲国家
      if (isMainSite) {
        return isNorthAmerican;
      }

      if (isGlobalSite) {
        return isEuropean;
      }

      // 未知站点，不验证
      return true;
    },

    /**
     * 获取默认选中的国家代码
     * 优先级：用户手动选择 > 用户账户 region（缓存）
     * 每个优先级都会验证 region 是否适合当前站点，不适合则跳过
     * 不再使用 IP 检测作为默认选中
     * @returns {String} 国家代码或空字符串
     */
    getDefaultRegion() {
      // 以 Shopify 当前市场为准，避免本地缓存与实际货币不一致。
      const currentCountry = document.documentElement.dataset.isoCode;
      if (currentCountry && this.isRegionValidForCurrentSite(currentCountry)) {
        return currentCountry;
      }
      // 1. 最高优先级：用户手动选择的国家（永久缓存）
      try {
        const userSelected = localStorage.getItem('user_selected_country');
        if (userSelected) {
          console.log('[Country Selector] 检查用户手动选择:', userSelected);
          if (this.isRegionValidForCurrentSite(userSelected)) {
            console.log('[Country Selector] 使用用户手动选择的国家:', userSelected);
            return userSelected;
          }
        }
      } catch (e) {
        console.error('[Country Selector] 读取用户手动选择失败:', e);
      }

      // 2. 次优先级：用户账户 region（从 token 直接读取）
      try {
        if (window.cognitoUserInfo) {
          const accountRegion = window.cognitoUserInfo.getRegion();
          if (accountRegion) {
            console.log('[Country Selector] 从 token 读取账户 region:', accountRegion);
            if (this.isRegionValidForCurrentSite(accountRegion)) {
              console.log('[Country Selector] 使用账户 region:', accountRegion);
              return accountRegion;
            } else {
              console.log('[Country Selector] 账户 region 不匹配当前站点，跳过');
            }
          }
        }
      } catch (e) {
        console.error('[Country Selector] 获取用户账户 region 失败:', e);
      }
      return '';
    },

    /**
     * 根据国家代码获取国旗图标 URL
     * @param {String} countryCode - 国家代码（如 'US', 'DE'）
     * @returns {String} 国旗图标 URL
     */
    getFlagUrl(countryCode) {
      if (!countryCode) {
        return '';
      }
      return `https://flagicons.lipis.dev/flags/4x3/${countryCode.toLowerCase()}.svg`;
    },

    /**
     * 获取当前选中国家的国旗图标 URL
     * @returns {String} 国旗图标 URL 或空字符串
     */
    getSelectedFlagUrl() {
      return this.getFlagUrl(this.selectedCountry);
    },

    /**
     * 弹窗打开后才返回国旗 URL，避免隐藏弹窗内图片提前加载
     * @param {String} countryCode - 国家代码
     * @returns {String} 国旗图标 URL 或空字符串
     */
    getLazyFlagUrl(countryCode) {
      if (!this.flagsLoaded) {
        return '';
      }
      return this.getFlagUrl(countryCode);
    },

    /**
     * 清除用户选择的缓存
     * 可用于重置功能或特殊场景
     * @param {Boolean} clearManualSelection - 是否清除用户手动选择（默认 true）
     */
    clearUserSelection(clearManualSelection = true) {
      try {
        if (clearManualSelection) {
          localStorage.removeItem('user_selected_country');
          console.log('[Country Selector] 已清除用户手动选择的缓存');
        }
      } catch (e) {
        console.error('[Country Selector] 清除缓存失败:', e);
      }
    }
  });

  /**
   * 注册表单的国家选择器组件（Alpine.data）
   * 管理表单字段的显示状态和已确认的国家
   */
  Alpine.data('countrySelector', () => ({
    // 已确认的国家代码（用于提交表单）
    confirmedCountry: '',

    // 已确认的国家名称（用于显示）
    confirmedCountryName: '',

    /**
     * 组件初始化
     */
    init() {
      // 监听国家选择事件
      document.addEventListener('country-selected', (e) => {
        this.confirmedCountry = e.detail.code;
        this.confirmedCountryName = e.detail.name;
      });
    },

    /**
     * 打开弹窗选择国家
     */
    openModal() {
      Alpine.store('countryModal').openModal(this.confirmedCountry);
    },

    /**
     * 获取国家名称（用于显示在输入框中）
     * @returns {String} 国家名称
     */
    getCountryDisplayName() {
      return this.confirmedCountryName || '';
    },

    /**
     * 获取国家代码（用于提交表单）
     * @returns {String} 国家代码
     */
    getCountryCode() {
      return this.confirmedCountry || '';
    }
  }));
});
